// extracted by css-extract-rspack-plugin
export default {"tableRow":"tableRow-nrsxUd","unreadTableRow":"unreadTableRow-JiCq28","expandCell":"expandCell-kb5VnP","tableCell":"tableCell-tiTgye"};